import { checkDefined } from 'faro-common-model';
export function toCountry(country) {
    checkDefined(country.id, 'Country', 'id');
    checkDefined(country.englishShortName, 'Country', 'englishShortName');
    checkDefined(country.alpha2Code, 'Country', 'alpha2Code');
    checkDefined(country.alpha3Code, 'Country', 'alpha3Code');
    checkDefined(country.numericCode, 'Country', 'numericCode');
    return {
        id: country.id,
        englishShortName: country.englishShortName,
        alpha2Code: country.alpha2Code,
        alpha3Code: country.alpha3Code,
        numericCode: country.numericCode,
    };
}
//# sourceMappingURL=country.js.map